import { render, staticRenderFns } from "./ForcCitationCountComparison.vue?vue&type=template&id=1bf634e6&"
import script from "./ForcCitationCountComparison.vue?vue&type=script&lang=js&"
export * from "./ForcCitationCountComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports